var exports = {
  "kL": "container__ig4jYt",
  "G1": "position__8abW96",
  "d$": "arrows__si-M95",
  "Gv": "backButton__NjmnoJ",
  "z9": "bounce__FQZBo8",
};

module.exports = exports;
